<div *ngIf="loader" id="spinerLoader" class="container">
    <div class="loader">Loading...</div>
</div>
<div class="modal-header py-0">
    <div class="d-flex justify-content-between">
        <span>
            <h4>{{ dialogData.headerName }}</h4>
        </span>
        <button mat-dialog-close class="close close-btn" type="button" (click)="closeModel(); resetForm(addEditMembersForm)">
            <i class="fa fa-close fa-md"></i>
        </button>
    </div>
</div>
<form #addEditMembersForm="ngForm" name="addEditMembersForm">
    <mat-dialog-content>
        <div id="modal-body" class="modal-body scrollbarView">
            <div class="member-card">
                <h4 class="filter-options inline" style="display: inline">Account Details</h4>

                <div *ngIf="!isMemberEdit" class="text-right mr-2" style="display: inline; float: right">
                    <label>
                        <input name="diffuser" type="checkbox" [(ngModel)]="isDifferentUserName" />
                        <span> as a guest user </span>
                    </label>
                </div>
                <br /><br />
                <div *ngIf="isMemberEdit" class="row profile-section">
                    <div class="col-md-3">
                        <img class="member-img member-img-height" alt="..." [src]="memberImage" />
                    </div>
                    <div class="col-md-9 profile-details">
                        <div class="col-md-12 ml-0 pl-0">
                            <label class="col-md-4">Email</label>
                            <label class="label-header-color col-md-8 padding-input breakWord">{{ memberDetail?.contact.emailId }}</label>
                        </div>

                        <div class="col-md-12 ml-0 pl-0">
                            <label class="col-md-4">Profile Image </label>
                            <label class="label-header-color col-md-8 padding-input breakWord d-flex">
                                <input
                                    id="editProfile"
                                    class="mt-2 cursorPointer"
                                    accept=".jpg,.jpeg,.png"
                                    name="fName"
                                    name="editMemberProfile"
                                    type="file"
                                    [style.width]="imageName != undefined ? '85px' : '100%'"
                                    [(ngModel)]="editMemberProfile"
                                    (input)="uploadMemberProfile($event, editMemberProfile, 'editProfile', true)"
                                />
                                <span *ngIf="imageName != undefined" class="mt-2 ml-2">{{ imageName }}</span>
                            </label>
                        </div>
                    </div>
                </div>
                <div *ngIf="!isMemberEdit" class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <div>
                                <label
                                    >Email ID<span *ngIf="!isDifferentUserName" class="text-danger"><b>*</b></span></label
                                >
                                <input
                                    id="CMemail"
                                    class="form-control"
                                    #email="ngModel"
                                    autocomplete="new-password"
                                    name="email"
                                    pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-z]{2,4}$"
                                    placeholder="Email"
                                    required
                                    type="email"
                                    [disabled]="isDifferentUserName"
                                    [ngClass]="{ 'is-invalid': addEditMembersForm.submitted && email.invalid && !isDifferentUserName }"
                                    [(ngModel)]="memberDetail.contact.emailId"
                                    (change)="checkUserExist(memberDetail.contact.emailId); checkEmailValidForAdmin(email.value)"
                                />
                                <div *ngIf="addEditMembersForm.submitted && email.invalid && !isDifferentUserName" class="invalid-feedback">
                                    <div *ngIf="email.errors.required">
                                        <span class="text-danger"> Email is required.</span>
                                    </div>
                                    <div *ngIf="email.errors.pattern">
                                        <span class="text-danger">Email not valid.</span>
                                    </div>
                                    <div *ngIf="emailError" class="text-danger">User already exists.</div>
                                </div>
                                <div *ngIf="isEmailErrorForExecutiveAdminRole" class="text-danger">
                                    Email Id must contain "@trinityairmedical.com" or "@srta.com" for Executive Admin Role
                                </div>
                                <div *ngIf="emailError" class="text-danger" class="pl-1">User already exists.</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <div>
                                <label
                                    >Password
                                    <span *ngIf="!isDifferentUserName" class="text-danger"
                                        ><b>*</b>&nbsp;
                                        <i
                                            class="fa fa-question-circle fa-lg red-tooltip"
                                            aria-hidden="true"
                                            data-toggle="tooltip"
                                            title="Password must be minimum of 8 characters with 1 uppercase,
                              1 lowercase, 1 digit and 1 special symbol."
                                        ></i> </span
                                ></label>
                                <input
                                    id="password"
                                    class="form-control"
                                    #password="ngModel"
                                    name="password"
                                    pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*?[0-9])(?=.*?[!@#$%^&*+`~'=?\|\]\[\(\)\-<>/]).{8,}"
                                    placeholder="Password"
                                    required
                                    title="Password must be minimum of 8 characters with 1 uppercase,
                              1 lowercase, 1 digit and 1 special symbol."
                                    type="password"
                                    [disabled]="isDifferentUserName"
                                    [ngClass]="{
                                        'is-invalid': addEditMembersForm.submitted && email.invalid && !isDifferentUserName,
                                    }"
                                    [(ngModel)]="memberDetail.password"
                                />
                            </div>
                            <div *ngIf="addEditMembersForm.submitted && password.invalid && !isDifferentUserName" class="invalid-feedback">
                                <div *ngIf="password.errors.required">
                                    <span class="text-danger">
                                        Password must be minimum of 8 characters with 1 uppercase, 1 lowercase, 1 digit and 1 special
                                        symbol.</span
                                    >
                                </div>
                                <div *ngIf="password.errors.pattern">
                                    <span class="text-danger"
                                        >Password must be minimum of 8 characters with 1 uppercase, 1 lowercase, 1 digit and 1 special
                                        symbol.</span
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="!isMemberEdit" class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>System Role<span *ngIf="!isDifferentUserName" class="text-danger">*</span></label>
                            <div class="multirole-container text-bold float-right">Default Role</div>
                            <ng-container *ngFor="let role of roleList; let i = index">
                                <div id="role{{ i }}" class="multirole">
                                    <input
                                        id="multiple-role-{{ role?.rolename }}"
                                        name="selectedMultipleRole"
                                        type="checkbox"
                                        [checked]="
                                            (assignedDefaultRole == role?.roleid || assignedMultipleRoles.has(role?.roleid)) &&
                                            !isDifferentUserName
                                        "
                                        [disabled]="assignedDefaultRole == role?.roleid || memberDetail.isGuestUser || isDifferentUserName"
                                        [value]="role?.roleid"
                                        (change)="selectMultipleRole($event); checkEmailValidForAdmin(memberDetail.contact.emailId)"
                                    />
                                    {{ role?.rolename }}
                                    <input
                                        id="default-role-{{ role?.rolename }}"
                                        class="float-right"
                                        name="defaultRole"
                                        type="radio"
                                        [checked]="assignedDefaultRole && assignedDefaultRole == role?.roleid && !isDifferentUserName"
                                        [disabled]="isDifferentUserName"
                                        [value]="role?.roleid"
                                        [(ngModel)]="assignedDefaultRole"
                                        (change)="
                                            isDefaultRoleSelected = !!assignedDefaultRole;
                                            checkEmailValidForAdmin(memberDetail.contact.emailId)
                                        "
                                    />
                                </div>
                            </ng-container>
                            <div *ngIf="isDefaultRoleSelected === false" class="invalid-feedback">
                                <span class="text-danger">Default role is required.</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Upload Profile Picture :</label>
                            <label class="d-flex">
                                <input
                                    id="profile"
                                    class="mt-2 cursorPointer"
                                    accept=".jpg,.jpeg,.png"
                                    name="memberImage"
                                    type="file"
                                    [(ngModel)]="memberImage"
                                    (input)="uploadMemberProfile($event, memberImage, 'profile', true)"
                                />
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="member-card">
                <h4 class="filter-options">Personal Details</h4>
                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>First Name<span class="text-danger">*</span></label>
                            <input
                                id="addFirstName"
                                class="form-control"
                                #add_FirstName="ngModel"
                                name="add_FirstName"
                                placeholder="First Name"
                                required
                                type="text"
                                [ngClass]="{
                                    'is-invalid': addEditMembersForm.submitted && add_FirstName.invalid,
                                }"
                                [(ngModel)]="memberDetail.firstName"
                            />
                            <div *ngIf="addEditMembersForm.submitted && add_FirstName.invalid" class="invalid-feedback">
                                <div *ngIf="add_FirstName.errors.required">
                                    <span class="text-danger">First Name is required.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>MI</label>
                            <input
                                id="addMiddleName"
                                class="form-control"
                                name="add_MiddleName"
                                placeholder="MI"
                                type="text"
                                [(ngModel)]="memberDetail.middleName"
                            />
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Last Name<span class="text-danger">*</span></label>
                            <input
                                id="addLastName"
                                class="form-control"
                                #add_LastName="ngModel"
                                name="add_LastName"
                                placeholder="Last Name"
                                required
                                type="text"
                                [ngClass]="{
                                    'is-invalid': addEditMembersForm.submitted && add_LastName.invalid,
                                }"
                                [(ngModel)]="memberDetail.lastName"
                            />
                            <div *ngIf="addEditMembersForm.submitted && add_LastName.invalid" class="invalid-feedback">
                                <div *ngIf="add_LastName.errors.required">
                                    <span class="text-danger">Last Name is required.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label
                                >Mobile Number<span class="text-danger"><b>*</b></span></label
                            >
                            <input
                                id="addMobileNumber"
                                class="form-control"
                                #add_MobileNumber="ngModel"
                                maxlength="14"
                                minlength="14"
                                name="add_MobileNumber"
                                pattern="\(?\d+\)?[-.\s]?\d+[-.\s]?\d+"
                                placeholder="(xxx) xxx-xxxx"
                                required
                                type="text"
                                [ngClass]="{
                                    'is-invalid': addEditMembersForm.submitted && add_MobileNumber.invalid,
                                }"
                                [ngModel]="memberDetail.contact.phoneNumber | phoneNumberPipe"
                                (ngModelChange)="memberDetail.contact.phoneNumber = $event"
                            />
                            <div *ngIf="addEditMembersForm.submitted && add_MobileNumber.invalid" class="invalid-feedback">
                                <div *ngIf="add_MobileNumber.errors.required">
                                    <span class="text-danger">Phone Number is required.</span>
                                </div>
                                <div *ngIf="add_MobileNumber.errors.minlength">
                                    <span class="text-danger">Phone must have 10 digits.</span>
                                </div>
                                <div *ngIf="add_MobileNumber.errors.pattern">
                                    <span class="text-danger">Phone Number not valid.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="isCustomer" class="col-md-4">
                        <div class="form-group">
                            <label>Gender</label><span class="text-danger">*</span>
                            <div class="radio my-0">
                                <label
                                    ><input
                                        name="gender"
                                        required
                                        type="radio"
                                        [value]="genderType.male"
                                        [(ngModel)]="memberDetail.gender"
                                    />Male</label
                                >
                                <label class="ml-4"
                                    ><input
                                        name="gender"
                                        required
                                        type="radio"
                                        [value]="genderType.female"
                                        [(ngModel)]="memberDetail.gender"
                                    />Female</label
                                >
                                <label class="ml-4"
                                    ><input
                                        name="gender"
                                        required
                                        type="radio"
                                        [value]="genderType.anotherGender"
                                        [(ngModel)]="memberDetail.gender"
                                    />Another Gender</label
                                >
                            </div>
                            <div *ngIf="addEditMembersForm.submitted && addEditMembersForm.controls['gender'].invalid">
                                <span class="text-danger">Gender is required.</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="member-card">
                <h4 class="filter-options">Address Details</h4>
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Street Address</label>
                            <input
                                id="CMStreetAddress"
                                class="form-control"
                                name="streetAddress"
                                placeholder="Street Address"
                                type="text"
                                [(ngModel)]="memberDetail.address.streetAddress"
                            />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Zipcode</label>
                            <input
                                id="CMZipcode"
                                class="form-control"
                                maxlength="5"
                                minlength="5"
                                name="Zipcode"
                                pattern="[0-9]+"
                                placeholder="Zipcode"
                                type="text"
                                [(ngModel)]="memberDetail.address.zipcode"
                            />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>State</label>
                            <select
                                class="form-control"
                                name="memberDetail.address.stateId"
                                [(ngModel)]="memberDetail.address.stateId"
                                (change)="getCityBystate(memberDetail.address.stateId)"
                            >
                                <option disabled selected [value]="null">Select State</option>
                                <option *ngFor="let item of StateList" [value]="item.stateId">
                                    {{ item?.stateName }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>City</label>
                            <select class="form-control" name="city" [(ngModel)]="memberDetail.address.city">
                                <option disabled selected value="">Select City</option>
                                <option *ngFor="let city of cityList" [value]="city.cityName">
                                    {{ city.cityName }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions>
        <div class="modal-footer pt-3 mb-3 col-lg-12 col-md-12 col-sm-12 col-xs-12 float-right">
            <button
                mat-dialog-close
                class="flat-butt flat-danger-butt flat-danger-grad-butt margin-right-10"
                type="button"
                (click)="closeModel(); resetForm(addEditMembersForm)"
            >
                Cancel
            </button>
            <button class="flat-butt flat-info-butt flat-info-grad-butt save-btn" type="submit" (click)="saveData(addEditMembersForm)">
                Save Changes
            </button>
        </div>
    </mat-dialog-actions>
</form>
